import { ReactNode } from 'react';
import { Trans } from '@lingui/macro';
import { ContinueApplicationButton } from 'components/ContinueApplicationButton/ContinueApplicationButton';
import { FundingRequirements } from 'components/FundingRequirements/FundingRequirements';
import { RejectOfferButton } from 'components/ReviewOffer/RejectOfferButton/RejectOfferButton';
import { TalkingToCustomer } from 'components/TalkingToCustomer/TalkingToCustomer';
import { TIntroducerApplication } from 'lendingApi/applications.types';
import { APPLICATION_STATUS } from 'utils/applications/applications.config';
import { ReviewOffer } from '../../ReviewOffer/ReviewOffer';
import { RefreshOfferButton } from '../RefreshOfferButton/RefreshOfferButton';
import { SummaryText } from '../SummaryText/SummaryText';

type TStatusComponents = {
  bottomContent: ReactNode | null;
  sideContent: ReactNode | null;
};

export const getStatusComponents = (
  applicationStatus: TIntroducerApplication['status'],
  isPartnerChannel: boolean,
): TStatusComponents => {
  if (isPartnerChannel) {
    if (applicationStatus === APPLICATION_STATUS.talking_to_customer) {
      return { bottomContent: <TalkingToCustomer />, sideContent: null };
    }

    return { bottomContent: null, sideContent: null };
  }

  let content: Partial<TStatusComponents> = {};
  if (
    applicationStatus === APPLICATION_STATUS.deferred ||
    applicationStatus === APPLICATION_STATUS.declined
  ) {
    content = { bottomContent: <SummaryText /> };
  } else if (applicationStatus === APPLICATION_STATUS.offer_rejected) {
    content = {
      bottomContent: (
        <SummaryText>
          {(phoneNumber, phoneNumberLink) => (
            <Trans>
              If you'd like to refresh this offer, please give us a ring on{' '}
              <a href={`tel:${phoneNumberLink}`}>{phoneNumber}</a>.
            </Trans>
          )}
        </SummaryText>
      ),
    };
  } else if (
    applicationStatus === APPLICATION_STATUS.offered ||
    applicationStatus === APPLICATION_STATUS.conditional_offer
  ) {
    content = {
      bottomContent: <ReviewOffer />,
      sideContent: <RejectOfferButton />,
    };
  } else if (applicationStatus === APPLICATION_STATUS.expired) {
    content = { bottomContent: <RefreshOfferButton /> };
  } else if (applicationStatus === APPLICATION_STATUS.talking_to_customer) {
    content = { bottomContent: <TalkingToCustomer /> };
  } else if (applicationStatus === APPLICATION_STATUS.open) {
    content = { bottomContent: <ContinueApplicationButton /> };
  }
  return { bottomContent: null, sideContent: null, ...content };
};
